
import { User } from '../types';

const SESSION_KEY = 'id_pro_current_user';

// 简易设备指纹生成
const getBrowserFingerprint = () => {
  try {
    const data = [
      navigator.userAgent,
      navigator.language,
      screen.colorDepth,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
      (window as any).devicePixelRatio || 1
    ].join('###');
    
    // 简单的字符串 Hash
    let hash = 0;
    for (let i = 0; i < data.length; i++) {
      const char = data.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return 'FP-' + Math.abs(hash).toString(36).toUpperCase();
  } catch (e) {
    return 'FP-UNKNOWN';
  }
};

export const authService = {
  login: async (username: string, password: string): Promise<any> => {
    try {
      const fingerprint = getBrowserFingerprint();
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, action: 'login', fingerprint })
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem(SESSION_KEY, JSON.stringify(data.user));
      }
      return data;
    } catch (e) {
      return { success: false, message: '网络连接失败' };
    }
  },

  register: async (username: string, email: string, password: string): Promise<any> => {
    try {
      const fingerprint = getBrowserFingerprint();
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password, action: 'register', fingerprint })
      });
      return await res.json();
    } catch (e) {
      return { success: false, message: '网络连接失败' };
    }
  },

  logout: () => {
    localStorage.removeItem(SESSION_KEY);
  },

  getCurrentUser: (): User | null => {
    const data = localStorage.getItem(SESSION_KEY);
    return data ? JSON.parse(data) : null;
  },

  resendCode: async (usernameOrEmail: string): Promise<any> => {
    const res = await fetch('/api/auth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: usernameOrEmail, action: 'resend-code' })
    });
    return await res.json();
  },

  verifyEmail: async (usernameOrEmail: string, token: string): Promise<any> => {
    const res = await fetch('/api/auth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: usernameOrEmail, token, action: 'verify-email' })
    });
    return await res.json();
  },

  // Fix: Added missing method to handle password reset requests
  requestPasswordReset: async (email: string): Promise<any> => {
    try {
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, action: 'request-password-reset' })
      });
      return await res.json();
    } catch (e) {
      return { success: false, message: '网络连接失败' };
    }
  },

  // Fix: Added missing method to complete password reset with token
  completePasswordReset: async (email: string, token: string, password: string): Promise<any> => {
    try {
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, password, action: 'complete-password-reset' })
      });
      return await res.json();
    } catch (e) {
      return { success: false, message: '网络连接失败' };
    }
  },

  // Fix: Added missing method to update password while logged in
  changePassword: async (username: string, oldPassword: string, newPassword: string): Promise<any> => {
    try {
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, oldPassword, newPassword, action: 'change-password' })
      });
      return await res.json();
    } catch (e) {
      return { success: false, message: '网络连接失败' };
    }
  }
};
